import React from 'react'

const MinusIcon = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M19.2852 13.0278L19.2852 10.9707L13.0285 10.9707L10.9715 10.9707L5.71481 10.9707L5.71481 13.0278L10.9715 13.0278L13.0285 13.0278L19.2852 13.0278Z" fill="white"/>
    </svg>
  )
}

export default MinusIcon
